import Validator from "@tinqin/tinqin-utils/src/validations";
import internalStateService from "./InternalStateService";
import translationService from "./TranslationService";
import messageService from "./MessageService";
import NewValidationService from "./NewValidationService";
import ObjectUtils from "@tinqin/tinqin-utils/src/object";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";
//what we need from this function:
//from the provided data type of the component should extract the function literals on which the validation will be executed
//or
//we are expecting just the component type and there will be a descriptor with the function literals for each component
//consider the case with required flag and regular expression
//the output will be list of validation literals and an object of validation messages
//we need expression when regular expression flag
//and locales for some of the validations
function getValidationMethod(props = {}, validations, widgetId) {
    if (validations && validations.length) {
        return NewValidationService.getValidationMethod(validations, props, widgetId);
    }
    let validationProperties = getValidationProperties(props);
    let validationLiterals = getValidationLiterals(validationProperties);
    let validationMessage;

    //Note: Project can define custom validations and add them to WebUI using addValidations method;
    let projectValidations = internalStateService.getValidations({ widgetId });
    let validationOptions = validationProperties.options || {};
    validationOptions.extraValidations = projectValidations;

    validationMessage = getMessages(validationLiterals, validationProperties.validationMessages);

    return Validator.createValidationMethod(
        validationLiterals,
        validationMessage,
        validationOptions
    );
}

//validation messages management
//there are businessError, validationMessage and requiredMessage
//T-Utils expecting default message in the message object
//input object of messages
//output validationRFunctionLiteral : message, default: message
//TODO different messages depending on the component data type
function getMessages(validationRules, componentValidationMessages = {}) {
    let validationMessages = Object.assign({}, componentValidationMessages);

    let defaultMessage = componentValidationMessages.default;

    for (let rule of validationRules) {
        validationMessages[rule] = validationMessages[rule] || defaultMessage;
    }

    return validationMessages;
}

//gather container properties and pass them to the validation service
function getValidationProperties(props = {}, options = {}) {
    //1. validation options
    let validationProperties = {
        options: addValidationOptions(props, options)
    };
    //2. depending on data type  - options required for some types
    //validation type other than required
    validationProperties.dataType = props.validationType || props.dataType;
    //3. required validation
    //TODO to remove -  used when perform flow validations
    let requiredFlag = props.required || props.__required;
    validationProperties.required = requiredFlag ? "required" : false;
    //4. regular expression
    if (props.regExp) {
        validationProperties.regExp = "regExp";
    }
    //5. error message
    // let requiredMessageTranslation = translationService.translate("requiredMessage");
    let requiredMessageTranslation = messageService.getRequiredMessage();
    let defaultMessage = translationService.translate("defaultValidationMessage");
    let requiredMessage = props.requiredMessage || requiredMessageTranslation;
    let propsErrorMessage = props.validationMessage || defaultMessage;
    let validationMessages;
    validationMessages = {
        default: propsErrorMessage,
        required: requiredMessage
    };

    validationProperties.validationMessages = validationMessages;

    return validationProperties;
}
//return an array of literals that represent validation functions
function getValidationLiterals(validationProperties = {}) {
    let validationLiterals = [];
    //if data type exist take the validation literal and return it with corresponding message
    if (validationProperties.dataType && validationProperties.dataType !== "string") {
        validationLiterals.push(validationProperties.dataType);
    }
    //check required as well
    if (validationProperties.required) {
        validationLiterals.push(validationProperties.required);
    }
    //check regular expressions as well
    if (validationProperties.regExp) {
        validationLiterals.push(validationProperties.regExp);
    }

    return validationLiterals;
}
//allow container to add own options
//expecting container to provide its options
//not to have default options
function addValidationOptions(containerProps = {}, options = {}) {
    let validationOptions = {};

    let defaultLocales = [internalStateService.getGlobalProperty("locale")];
    validationOptions.locales = containerProps.locales || defaultLocales;

    if (containerProps.regExp) {
        validationOptions.regExp = containerProps.regExp;
    }
    if (containerProps.maxSize) {
        validationOptions.maxSize = containerProps.maxSize;
    }
    if (containerProps.range) {
        validationOptions.range = containerProps.range;
    }
    if (containerProps.fileExtension) {
        validationOptions.fileExtension = containerProps.fileExtension;
    }

    return Object.assign({}, validationOptions, options);
}

function executeValidation(toValidate, entity, options = {}) {
    let validationMethod = getValidationMethod(
        entity.properties,
        entity.validations,
        options.widgetId
    );

    let executeValidation = validationMethod(toValidate);
    let result = {};

    if (!ObjectUtils.isEmpty(executeValidation)) {
        if (executeValidation.error && !ObjectUtils.isEmpty(executeValidation.error)) {
            if (!options.silent) {
                WEBUILogs.warn("entity has validation failed:");
                WEBUILogs.warn(entity);
            }
            result.valid = false;
        }
        result["failedValidations"] = executeValidation;
    }

    return result;
}

export default {
    getValidationMethod,
    getValidationProperties,
    executeValidation
};
